export default {
  AUTH_DATA_DASHBOARD: '概览',
  AUTH_USER_ADM: '系统管理',
  AUTH_SYS_APP_CONFIG: '配置',
  AUTH_CUSTOMER_SERVICE_ADM: '客户服务',
  AUTH_MERCHANT_MANAGER: '商户管理',
  AUTH_SETTLEMENT_MANAGER: '收款交易/付款交易',
  AUTH_SETTLEMENT_BALANCE: '余额管理',
  AUTH_SETTLEMENT_RECHARGE: '充值',
  AUTH_SETTLEMENT_WITHDRAW: '提现',
  AUTH_SETTLEMENT_STATISTICS_FILE_DOWN: '交易汇总',
  AUTH_PAYMENT_LINK: 'Payment Links',
  AUTH_DISBURSEMENT_APPROVE: '付款审核',
  AUTH_DISBURSEMENT_PAGE: '小额付款',
  AUTH_DISBURSEMENT_CHECK: '付款检查',
  AUTH_DISBURSEMENT_CONFIRM: '付款创建',
  AUTH_PAYMENT_PAGE: 'Pagement Page',
  AUTH_SETTLEMENT_BALANCE_DETAIL: '余额详情',
  AUTH_SETTLEMENT_TRANSFER: '关联商户转账',
  AUTH_TRANSACTION_PAYIN: '代收',
  AUTH_TRANSACTION_PAYOUT: '代付',
  AUTH_TRANSACTION_SUMMARY: '交易汇总',
  AUTH_CUSTOMER_SERVICE_PAYIN: '代收查询',
  AUTH_CUSTOMER_SERVICE_PAYOUT: '代付查询',
  AUTH_CUSTOMER_SERVICE_TICKET: '客服工单',
  AUTH_ROLE_ADM: '角色管理',
  AUTH_MERCHANT_STORE_CREATE: '商户店铺码创建',
  AUTH_MERCHANT_STORE_DOWNLOAD: '商户店铺码下载',
  AUTH_VA_COLLECTION_ADM: 'VA 收款',
  AUTH_LARGE_AMOUNT_KEY: 'Send Payments',
  AUTH_FINANCIALS_SETTING: '资金设置',
  QRCODE_KEY: '收款码',
  AUTH_QRCODE_ADM: '收款码列表',
  AUTH_LARGE_AMOUNT: '大额付款',
  AUTH_LARGE_CREATE_DISBURSEMENT: '大额收款人',
  DASHBOARD_KEY: '概览',
  FINANCIAL_KEY: '资金管理',
  TRANSACTION_KEY: '交易管理',
  CUSTSER_KEY: '客户服务',
  PAYMENT_LINK_KEY: 'Payment links',
  SEND_PAYMENT_KEY: 'Send Payments',
  PAYMENT_PAGE_KEY: 'Payment Page',
  DEVELOPER_KEY: '开发者',
  SYS_KEY: '系统管理',
  MCH_STORE_KEY: '店铺二维码',
  VA_COLLECTION_KEY: 'VA 收款',
  AUTH_TRANSACTION_REFUND: '退款交易',
  AUTH_PAYMENT_REFUND: '退款交易按钮',
  AUTH_CUSTOMER_SERVICE_REFUND: '退款交易查询',
  SPLIT_KEY: '平台',
  AUTH_SPLIT_PAYMENT: '分账交易',
  AUTH_SPLIT_MERCHANT: '商户',
  LARGE_AMOUNT_KEY: ''
}
